var config = {};

if (process.env.NODE_ENV === "production") {
  config.backend_url = "https://backend.myembassymyconsulate.org";
} else {
  config.backend_url = "http://localhost:3001";
}

module.exports = config;
